/* eslint-disable no-else-return */
import axios, { AxiosError } from 'axios';

let isRefreshing = false;
let failedRequestsQueue: {
  onSuccess: (token: string) => void;
  onFailure: (err: AxiosError<any>) => void;
}[] = [];

function signOut() {
  localStorage.removeItem('@Samasc:token');
  localStorage.removeItem('@Samasc:refresh_token');
  localStorage.removeItem('@Samasc:user');
}

// Em desenvolvimento local (yarn start em localhost), as requisições passam
// pelo proxy de dev (src/setupProxy.js) para evitar o bloqueio de CORS.
// Em produção, mantém a URL absoluta do backend (comportamento original).
const isLocalDev =
  typeof window !== 'undefined' && window.location.hostname === 'localhost';

const API_BASE_URL = isLocalDev
  ? '/dev-api'
  : 'https://samasc.cooasgo.com.br:3333';

export const api = axios.create({
  baseURL: API_BASE_URL,
  // baseURL: 'http://localhost:3001',
  // baseURL: 'https://deploy.cooasgo.samasc.com.br',
});

// Cliente sem sessão do usuário para rotas públicas de dispositivos. Evita
// enviar o Bearer do SAMASC e não aciona o fluxo de refresh/logout em uma TV.
export const apiPublic = axios.create({
  baseURL: API_BASE_URL,
});

// Interceptor para adicionar token dinamicamente em TODAS as requisições
api.interceptors.request.use(config => {
  const token = localStorage.getItem('@Samasc:token');

  if (token) {
    return {
      ...config,
      headers: {
        ...config.headers,
        authorization: `Bearer ${token}`,
      },
    };
  }

  return config;
});

export const apiPowerBI = axios.create({
  // baseURL: process.env.REACT_APP_API_URL,
  // baseURL: 'http://177.201.67.182:3333/',
  baseURL: 'https://powerbi.cooasgo.samasc.com.br/',
});

export const apiN8n = axios.create({
  baseURL: 'https://cooasgo.app.n8n.cloud/webhook-test',
  // auth: {
  //   username: 'n8n.samasc',
  //   password: '123456789',
  // },
});

export const apiGeninfo = axios.create({
  baseURL: 'https://samasc.cooasgo.com.br:3333/results-of-goals/filter-geninfo',
});

// Interceptor para adicionar token dinamicamente
apiGeninfo.interceptors.request.use(config => {
  const token = localStorage.getItem('@Samasc:token');

  if (token) {
    return {
      ...config,
      headers: {
        ...config.headers,
        authorization: `Bearer ${token}`,
      },
    };
  }

  return config;
});

export const apiPowerBiDashboard = axios.create({
  baseURL:
    'https://api.powerbi.com/beta/e9a74b56-c008-4411-9616-0a7f17e12dad/datasets/fc14a445-b4bb-4435-a72a-7a4e88de65f8/',
});

api.interceptors.response.use(
  response => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      if (error.response.data?.code === 'token.expired') {
        const token_refresh = localStorage.getItem('@Samasc:refresh_token');
        const originalConfig = error.config;

        if (!isRefreshing) {
          isRefreshing = true;
          api
            .post('/refresh-token', {
              refresh_token: token_refresh,
            })
            .then(response => {
              const { token } = response.data;

              localStorage.setItem('@Samasc:token', token);
              localStorage.setItem(
                '@Samasc:refresh_token',
                response.data.refresh_token,
              );

              api.defaults.headers.authorization = `Bearer ${token}`;
              failedRequestsQueue.forEach(request => request.onSuccess(token));
              failedRequestsQueue = [];
            })
            .catch(err => {
              failedRequestsQueue.forEach(request => request.onFailure(err));
              failedRequestsQueue = [];
            })
            .finally(() => {
              isRefreshing = false;
            });
        }
        return new Promise((resolve, reject) => {
          failedRequestsQueue.push({
            onSuccess: (token: string) => {
              // eslint-disable-next-line no-param-reassign
              originalConfig.headers.authorization = `Bearer ${token}`;

              resolve(api(originalConfig));
            },
            onFailure: (err: AxiosError) => {
              reject(err);
            },
          });
        });
      } else if (
        error.response.data?.message === 'Refresh Token does not exists!'
      ) {
        console.log('Refresh token não existe');
        signOut();
      } else if (error.response.data?.code === 'token.malformed') {
        console.log('Token mal formado');
        signOut();
      } else if (error.response.data?.message === 'Token Flopado') {
        console.log('Token flopado');
        signOut();
      } else {
        console.log('erro diferente');
        signOut();
      }
    }
    return Promise.reject(error);
  },
);
